import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navbar({ icon, title }) {
  const location = useLocation();

  // Function to check if the current path matches the link's path
  const isActive = (path) => location.pathname === path;

  return (
    <div className="flex mb-3 me- mr-[-0.5rem]">
      <div className="flex py-4 pr-4 gap-5 items-center text-2xl font-semibold w-32">
        <div className="text-seagreen text-3xl">{icon}</div>
        <h4 className="font-sans text-seagreen text-2xl z-10">{title}</h4>
      </div>
      <div className="hidden md:flex w-40">
        <div className="bg-primary">
          <div className="w-20 h-full bg-secondary rounded-tr-[50%]"></div>
        </div>
        <div className="w-20 bg-primary rounded-bl-[60%]"></div>
      </div>
      <div className="hidden md:flex justify-end pr-3 bg-primary gap-1 w-full flex-wrap">
       {[
  {
    path: '/MuhammadAli.pdf',
    label: 'Download Resume',
    external: true, // 👈 add this flag
  },
  {
    path: 'https://wa.me/923062767542?text=Hi,%20I%20would%20like%20to%20hire%20you',
    label: 'Hire Me',
    external: true,
  },
  { path: '/', label: 'Home' },
  { path: '/about', label: 'About' },
  { path: '/expertise', label: 'Expertise' },
  { path: '/projects', label: 'Projects' },
  { path: '/contact', label: 'Contact' },
].map((link) =>
  link?.external ? (
    <a
      key={link.path}
      href={link.path}
      target="_blank"
      rel="noopener noreferrer"
      className={`flex px-4 my-3 items-center font-semibold rounded-lg ${
        isActive(link.path)
          ? 'bg-seagreen text-white'
          : 'bg-secondary text-darkgrey'
      }`}
    >
      <h4 className="font-sans ">{link.label}</h4>
    </a>
  ) : (
    <Link
      key={link.path}
      to={link.path}
      className={`flex px-4 my-3 items-center font-semibold rounded-lg ${
        isActive(link.path)
          ? 'bg-seagreen text-white'
          : 'bg-secondary text-darkgrey'
      }`}
    >
      <h4 className="font-sans ">{link.label}</h4>
    </Link>
  )
)}

      </div>

      {/* <img src={web} alt="Me" class="w-20 rounded-lg hidden md:block" /> */}
    </div>
  );
}

export default Navbar;
